// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/httpv2/error.proto (package infinigence.infini.agentplatform.httpv2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ErrorData } from "../common/error_pb.js";
import { file_agentplatform_common_error } from "../common/error_pb.js";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/httpv2/error.proto.
 */
export const file_agentplatform_httpv2_error: GenFile = /*@__PURE__*/
  fileDesc("CiBhZ2VudHBsYXRmb3JtL2h0dHB2Mi9lcnJvci5wcm90bxInaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0uaHR0cHYyIukDCg1FcnJvclJlc3BvbnNlEocBCgRjb2RlGAEgASgJQnm6R3Y6CxIJImFwaS40MDQikgJm5Lia5Yqh56CB77yM5qGG5p625qiq5YiH5bGCIHZhbGlkYXRpb24uL2F1dGguL2ludGVybmFsLjxzdGF0dXM+77yMSGFuZGxlciDkuJrliqHlsYLnu5/kuIAgYXBpLjxzdGF0dXM+EnEKEGh0dHBfc3RhdHVzX2NvZGUYAiABKAVCRbpHQjoFEgM0MDSSAjjkuJrliqEgSFRUUCDnirbmgIHnoIHvvIjpgI/kvKAgSFRUUCBzdGF0dXMg5rC46L+cIDIwMO+8iVIQaHR0cF9zdGF0dXNfY29kZRJHChBzdWNjZXNzX3Jlc3BvbnNlGAMgASgIQhu6Rxg6BxIFZmFsc2WSAgzmsLjov5wgZmFsc2VSEHN1Y2Nlc3NfcmVzcG9uc2USWgoEZGF0YRgEIAEoCzIyLmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLmNvbW1vbi5FcnJvckRhdGFCGLpHFZICEuS4muWKoemUmeivr+ivpuaDhTo2ukczkgIwaHR0cHYyIOaJgOaciSBSUEMg5aSx6LSl5pe25YWx55So55qE5ZON5bqU5YyF57ucQlFaT2dpdGxhYi5pbmZpbmktYWkuY29tL21pemFyL2luZmluaWFpLWFnZW50aWMtaW5mcmEvY29tbW9uL2dycGNhcGlzL2h0dHB2MjtodHRwdjJiBnByb3RvMw", [file_agentplatform_common_error, file_gnostic_openapi_v3_annotations]);

/**
 * ErrorResponse 是 httpv2 所有 RPC 失败时共用的响应包络。
 * JSON wire 形态字段名与 {RpcName}Response 一致（code / http_status_code /
 * success_response / data），但 data 的 schema 是 common.ErrorData，不是业务 Data。
 *
 * 约定：HTTP 透传层永远 200（除 503/504 由网络/代理层产出），业务状态由
 * envelope 内字段表达。详见 docs/spec/rpc-spec.md §3。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.ErrorResponse
 */
export type ErrorResponse = Message<"infinigence.infini.agentplatform.httpv2.ErrorResponse"> & {
  /**
   * 业务码，格式：
   *   - 框架横切层：`validation.<status>` / `auth.<status>` / `internal.<status>`
   *   - Handler 业务层：统一 `api.<status>`（如 api.400 / api.404 / api.409）
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * 业务 HTTP 状态码（透传 HTTP status 永远 200）
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * 永远 false
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * 业务错误详情
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.common.ErrorData data = 4;
   */
  data?: ErrorData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ErrorResponse.
 * Use `create(ErrorResponseSchema)` to create a new message.
 */
export const ErrorResponseSchema: GenMessage<ErrorResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_error, 0);

